import { Action, createReducer, on } from '@ngrx/store';
import { AppointmentListActions } from './appointment-list.actions';

export const STORE_FEATURE_KEY_APPOINTMENTS_LIST = 'appointmentsList';

export interface AppointmentsListState {
    viewDeletedReminders: boolean;
    viewVoidAppointments: boolean; // Check if need to keep in store
    pageType: string;
}

export const initializeAppointmentsListState: AppointmentsListState = {
    viewDeletedReminders: false,
    viewVoidAppointments: false,
    pageType: 'DateAppointment'
};

const reducer = createReducer(
    initializeAppointmentsListState,
    on(AppointmentListActions.setViewDeletedReminders, (state, { payload }) =>
        ({ ...state,
           viewDeletedReminders: payload
        })),
    on(AppointmentListActions.setViewVoidAppointments, (state, { payload }) =>
        ({ ...state,
           viewVoidAppointments: payload
        })),
    on(AppointmentListActions.setPageType, (state, { payload }) =>
        ({ ...state,
            pageType: payload
        }))
);
export function AppointmentsListReducer(state: AppointmentsListState | undefined, action: Action) {
    return reducer(state, action);
}
